<template>
  <div>
    <base-header class="pb-8 pt-4"/>
    <div class="container-fluid mt--7">
      <coiffeur-appointment-card />
    </div>


  </div>
</template>

<script>
import CoiffeurAppointmentCard from "../../components/CoiffeurAppointmentCard";

export default {
  name: 'AppointmentList',
  components: {CoiffeurAppointmentCard},
}
</script>
